var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"z-10 absolute"},[_c('span',{staticClass:"context-menu bg-gray-100"},[(_vm.loading)?_c('i',{staticClass:"el-icon-loading text-blue-500",class:_vm.getVerticalAdjustment}):_c('i',{staticClass:"uil uil-ellipsis-h",class:_vm.getVerticalAdjustment})])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-0 mx-1"},[_c('span',{staticClass:"context-menu"})])
}]

export { render, staticRenderFns }